// extracted by mini-css-extract-plugin
module.exports = {"buttons":"_igAw--D","backNext":"_3N2Ea1u","back":"_2fGL0M3","reset":"_2k7aFiF","next":"_3CgjH1i","mobile":"_38DB_1p"};